import { always, concat, mergeDeepWith, mergeRight } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = {};

const setDetails = (state, action) => {
	return {
		...action.payload.details,
	};
};

const setAttachments = (state, action) => {
	const { attachments } = action.payload;
	const loadedAttachments = { taskAttachments: attachments };
	return mergeRight(state, loadedAttachments);
};

const setHistory = (state, action) => {
	const historyState = { history: action.payload.history };
	return mergeRight(state, historyState);
};

const addTaskNote = (state, action) => {
	const comment = {
		comments: [
			{
				comment: action.payload.comment,
				dateCreated: new Date().toISOString(),
				userCreatedFirstName: action.payload.firstName,
				userCreatedSurname: action.payload.surname,
			},
		],
	};
	return mergeDeepWith(concat, comment, state);
};

const partnerDetailsReducer = {
	[types.SET_TASK_DETAILS]: setDetails,
	[types.SET_TASK_ATTACHMENTS]: setAttachments,
	[types.ADD_TASK_NOTE]: addTaskNote,
	[types.SET_HISTORY]: setHistory,
	[types.RESET_REDUCER]: always(initialState),
};

export default handleActions(partnerDetailsReducer, initialState);
